import { Box, CircularProgress, Dialog, DialogContent, DialogTitle, Divider, Grid, IconButton } from '@material-ui/core'
import React from 'react'
import { ProjectDownloadReport } from './ProjectDownloadReport'
import { useReportProjectDownloadList } from '../../../common/CommonMutations';
import CloseIcon from "@material-ui/icons/Close";

export const ProjectDownloadDialog = ({ open, handleclose, projectnumber }: any) => {

    const { data: projectsList, isLoading } = useReportProjectDownloadList(projectnumber);


    return (
        <>
            <Dialog open={open} onClose={handleclose} fullWidth maxWidth="lg">
                <DialogTitle>
                    <Grid container alignItems="center">
                        <Grid item xs={11}>Project Number : {projectnumber}</Grid>
                        <Grid item xs={1} style={{ textAlign: "right" }}>
                            <IconButton onClick={handleclose}>
                                <CloseIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                </DialogTitle>
                <Divider />
                <DialogContent>
                    {isLoading ? (
                        <Box display="flex" justifyContent="center" alignItems="center" height="200px">
                            <CircularProgress size={40} />
                        </Box>
                    ) : (
                        <>
                            <Grid container spacing={2}>


                                <Grid item xs={12}>
                                    {projectsList?.workorders && (
                                        
                                        <ProjectDownloadReport data={projectsList.workorders} projectNumber={projectnumber} handleclose={handleclose} />
                                    )}
                                </Grid>
                            </Grid>
                        </>
                    )}
                </DialogContent>
            </Dialog>

        </>
    )
}


